import React, { useEffect } from 'react';
import Typewriter from 'typewriter-effect';
import logo from '../../../images/portfoilio.png'
import About from '../../About/About';
import Contact from '../../Contact/Contact';
import Aos from 'aos';
import 'aos/dist/aos.css';
import Project from '../../Project/Project';

const Home = () => {
    useEffect(() => {
        Aos.init()
    })
    
    return (
        <div
         data-aos="fade-up"
         data-aos-duration="3000"
          className="bg-gray-300 ">
            
           <div className="grid lg:grid-cols-2 px-20 ">
           <div 
        data-aos="zoom-in"
        data-aos-duration="3000"

        >
                <h1 className="text-justify text-5xl font-bold mb-5">Hi I'm Joy Biswas</h1>
                <div className="text-justify text-3xl font-bold text-red-400 py-5">
                <Typewriter
                options={{
                    strings:['Web Developer', 'React Developer', 'Front End Developer', 'MERN-STACK-DEVELOPER', 'JavaScript Developer', 'Programmer'],
                    autoStart: true,
                    loop: true,
                    delay:50,
                    deleteSpeed:50
                }}
                />
                </div>
                <p className="text-xl font-semibold text-justify  mb-10">A self-motivated and enthusiastic web developer. To gain confidence and fame using my potential in the field of web development and express my innovative creative skills for self and company growth. I always like to learn new things and have experience with new stuff.</p>
                
               <button className="bg-red-600 rounded px-5 py-2  text-white text-xl"><i class="fas fa-download"> <a   href="https://drive.google.com/uc?export=download&id=1jdFnsTD_AQmd4SeB1McztAAa-oHzZjBI">Resume</a></i></button> 
                
            </div>
            <div data-aos="zoom-in"
        data-aos-duration="3000">
                <img src={logo} alt="" />
            </div>
           </div>
                <div className="mt-20">
                    <About></About>
                </div>

                <div className="mt-20 ">
               
                    <Project></Project>
                </div>

                <div className="mt-20">
                    <Contact></Contact>
                </div>

        </div>
    );
};

export default Home;